const SONG_FILTERS = {
  boomy_trap: {
    name: "Shake your Boomy",
    genres: ["Trap"],
    value: "boomy_trap",
    previewUrl:
      "https://storage.googleapis.com/boomy-songs/hh_shake_your_boomy.mp3"
  },
  boomy_bap: {
    name: "Boomy Bap",
    genres: ["Hip Hop"],
    value: "boomy_bap",
    previewUrl: "https://storage.googleapis.com/boomy-songs/hh_boomy_bap.mp3"
  },
  mahogany_flex: {
    name: "Mahogany Flex",
    genres: ["Trap"],
    value: "mahogany_flex",
    previewUrl: "https://storage.googleapis.com/boomy-songs/hh_mahogany.mp3"
  },
  bouncey_house: {
    name: "Housified",
    genres: ["Hip Hop", "House"],
    value: "bouncey_house",
    previewUrl: "https://storage.googleapis.com/boomy-songs/hh_house.mp3"
  },
  icy_beat: {
    name: "Icy",
    genres: ["Trap"],
    value: "icy_beat",
    previewUrl: "https://storage.googleapis.com/boomy-songs/hh_icy.mp3"
  },
  rnb: {
    name: "R&B",
    genres: ["Hip Hop", "R&B"],
    value: "rnb",
    previewUrl: "https://storage.googleapis.com/boomy-songs/hh_rnb.mp3"
  },
  all_flavors: {
    name: "Roulette",
    genres: ["Random"],
    value: "all_flavors",
    previewUrl: "https://storage.googleapis.com/boomy-songs/hh_roullette.mp3"
  },
  reggaeton: {
    name: "Caliente Coast",
    genres: ["Reggaeton"],
    shortName: "Caliente Coast",
    value: "reggaeton",
    previewUrl: "https://storage.googleapis.com/boomy-songs/gg_reggaeton.mp3"
  },
  reggae: {
    name: "Jammin",
    genres: ["Reggae"],
    shortName: "Jammin",
    value: "reggae",
    previewUrl: "https://storage.googleapis.com/boomy-songs/gg_reggae.mp3"
  },
  reggae2: {
    name: "The Boomys",
    genres: ["Ska"],
    shortName: "The Boomys",
    value: "reggae2",
    previewUrl: "https://storage.googleapis.com/boomy-songs/gg_ska.mp3"
  },
  latin: {
    name: "Sunset Vibes",
    genres: ["Latin"],
    shortName: "Sunset Vibes",
    value: "latin",
    previewUrl: "https://storage.googleapis.com/boomy-songs/gg_latin.mp3"
  },
  latin_trap: {
    name: "Super Suave",
    genres: ["Latin", "Trap"],
    shortName: "SuperSuave",
    value: "latin_trap",
    previewUrl: "https://storage.googleapis.com/boomy-songs/gg_latin trap.mp3"
  },
  afrobeat: {
    name: "Sunset",
    genres: ["Afrobeat"],
    shortName: "Sunset",
    value: "afrobeat",
    previewUrl: "https://storage.googleapis.com/boomy-songs/gg_afrobeat1.mp3"
  },
  afrobeat2: {
    name: "Tropical Taste",
    genres: ["Afrobeat", "Jazz"],
    shortName: "Tropical Taste",
    value: "afrobeat2",
    previewUrl: "https://storage.googleapis.com/boomy-songs/gg_afrobeat2.mp3"
  },
  ambient_pulsing: {
    name: "Pulses",
    genres: ["Electronic", "Ambient"],
    value: "ambient_pulsing",
    previewUrl:
      "https://storage.googleapis.com/boomy-songs/preview_meditation_pulses.mp3"
  },
  ambient_acoustic: {
    name: "Natural",
    genres: ["Acoustic", "Ambient"],
    value: "ambient_acoustic",
    previewUrl:
      "https://storage.googleapis.com/boomy-songs/preview_meditation_natural.mp3"
  },
  ambient_electronic: {
    name: "Ambient",
    genres: ["Electronic", "Ambient"],
    value: "ambient_electronic",
    previewUrl:
      "https://storage.googleapis.com/boomy-songs/preview_meditation_electronic.mp3"
  },
  modern_hip_hop: {
    name: "Modern",
    genres: ["Experimental", "Hip Hop"],
    value: "modern_hip_hop",
    previewUrl:
      "https://storage.googleapis.com/boomy-songs/preview_beats_modern.mp3"
  },
  hard_trap: {
    name: "High Intensity",
    genres: ["Experimental", "Trap"],
    value: "hard_trap",
    previewUrl:
      "https://storage.googleapis.com/boomy-songs/preview_beats_high_intensity.mp3"
  },
  max_edm: {
    name: "Maximum Thump",
    genres: ["Experimental", "EDM"],
    value: "max_edm",
    previewUrl:
      "https://storage.googleapis.com/boomy-songs/preview_beats_maximum_thump.mp3"
  },
  chill_electronic: {
    name: "Electronic",
    genres: ["Experimental", "Electronic"],
    value: "chill_electronic",
    previewUrl:
      "https://storage.googleapis.com/boomy-songs/preview_beats_electronic.mp3"
  },
  vintage_beat: {
    name: "Vintage",
    genres: ["Experimental", "Vintage"],
    value: "vintage_beat",
    previewUrl:
      "https://storage.googleapis.com/boomy-songs/preview_beats_vintage.mp3"
  },
  ambient: {
    name: "Ambient",
    genres: ["Experimental", "Ambient"],
    value: "ambient",
    previewUrl:
      "https://storage.googleapis.com/boomy-songs/preview_beats_ambient.mp3"
  },
  unlimited: {
    name: "Unlimited",
    genres: ["Experimental", "Weird"],
    value: "unlimited",
    previewUrl:
      "https://storage.googleapis.com/boomy-songs/preview_beats_unlimited.mp3"
  },
  // rule_26: {
  //   name: "Emerging Lattice",
  //   value: "rule_26",
  //   previewUrl:
  //     "https://storage.googleapis.com/boomy-songs/preview_emerging_lattice.mp3"
  // },
  // rule_195: {
  //   name: "Tessellation",
  //   value: "rule_195",
  //   mp3Link:
  //     "https://storage.googleapis.com/boomy-songs/preview_tesselation.mp3"
  // },
  // rule_225: {
  //   name: "Entropic Dreams",
  //   value: "rule_225",
  //   mp3Link:
  //     "https://storage.googleapis.com/boomy-songs/preview_entropic_dreams.mp3"
  // },
  // rule_110: {
  //   name: "Acoustic Complexity",
  //   value: "rule_110",
  //   mp3Link:
  //     "https://storage.googleapis.com/boomy-songs/preview_acoustic_complexity.mp3"
  // },
  // rule_86: {
  //   name: "Quantum Tetrahedra",
  //   value: "rule_86",
  //   mp3Link: "https://storage.googleapis.com/boomy-songs/preview_quantum.mp3"
  // }
  morning_sun: {
    name: "Morning Sun",
    value: "morning_sun",
    genres: ["Lofi", "Uplifting"],
    previewUrl: "https://storage.googleapis.com/boomy-songs/lf_morning.mp3"
  },
  afternoon_nap: {
    name: "Afternoon Nap",
    value: "afternoon_nap",
    genres: ["Hip Hop", "Ambient"],
    previewUrl: "https://storage.googleapis.com/boomy-songs/lf_afternoon.mp3"
  },
  rainy_nights: {
    name: "Rainy Nights",
    value: "rainy_nights",
    genres: ["Lofi", "Hip Hop", "Dreamy"],
    previewUrl: "https://storage.googleapis.com/boomy-songs/lf_rainy.mp3"
  },
  house: {
    name: "Warehouse Groove",
    value: "house",
    genres: ["House", "EDM"],
    previewUrl: "https://storage.googleapis.com/boomy-songs/house.mp3"
  },
  electro_house: {
    name: "Hyperdrive",
    value: "electro_house",
    genres: ["Electro House", "Electronic"],
    previewUrl: "https://storage.googleapis.com/boomy-songs/electro_house.mp3"
  },
  chill_wave: {
    name: "Vapor",
    value: "chill_wave",
    genres: ["Chillwave"],
    previewUrl: "https://storage.googleapis.com/boomy-songs/chillwave.mp3"
  }
};

const SONG_STYLES = {
  wd_edm: {
    name: "Electronic Dance",
    description:
      "Get ready to move with EDM-style sweeps and drops over huge drums and synthesizers",
    value: "wd_edm",
    filters: [
      {
        ...SONG_FILTERS.house,
        selected: true
      },
      SONG_FILTERS.electro_house,
      SONG_FILTERS.chill_wave
    ],
    previewUrl: "https://storage.googleapis.com/boomy-songs/edm_all.mp3",
    credits: [
      {
        name: "@walker2076",
        url: "https://www.instagram.com/2076la/"
      }
    ],
    icon: "audio-mixer.svg"
  },
  wd_rap: {
    name: "Rap Beats",
    description:
      "Modern beats influenced by Hip Hop and Trap. Inspire a new dance, layer your verses, or just nod along.",
    value: "wd_rap",
    filters: [
      {
        ...SONG_FILTERS.boomy_trap,
        selected: true
      },
      SONG_FILTERS.boomy_bap,
      SONG_FILTERS.mahogany_flex,
      SONG_FILTERS.bouncey_house,
      SONG_FILTERS.icy_beat,
      SONG_FILTERS.rnb,
      SONG_FILTERS.all_flavors
    ],
    previewUrl: "https://storage.googleapis.com/boomy-songs/HH.mp3",
    credits: [
      {
        name: "@walker2076",
        url: "https://www.instagram.com/2076la/"
      }
    ],
    icon: "rap-beats.svg"
  },
  wd_lofi: {
    name: "Lo-Fi",
    description:
      "Grainy beats melt into nature-infused ambient sounds to center your focus, rain or shine.",
    value: "wd_lofi",
    filters: [
      {
        ...SONG_FILTERS.morning_sun,
        selected: true
      },
      SONG_FILTERS.afternoon_nap,
      SONG_FILTERS.rainy_nights
    ],
    previewUrl: "https://storage.googleapis.com/boomy-songs/LOFI.mp3",
    credits: [
      {
        name: "@walker2076",
        url: "https://www.instagram.com/2076la/"
      }
    ],
    icon: "moon-cloud-rain.svg"
  },
  wd_groove: {
    name: "Global Groove",
    description:
      "Chill beats inspired by globally popular styles like Latin, Reggae, and Afrobeat.",
    value: "wd_groove",
    filters: [
      {
        ...SONG_FILTERS.reggaeton,
        selected: true
      },
      SONG_FILTERS.reggae,
      SONG_FILTERS.reggae2,
      SONG_FILTERS.latin,
      SONG_FILTERS.latin_trap,
      SONG_FILTERS.afrobeat,
      SONG_FILTERS.afrobeat2
    ],
    previewUrl: "https://storage.googleapis.com/boomy-songs/GG.mp3",
    credits: [
      {
        name: "@walker2076",
        url: "https://www.instagram.com/2076la/"
      }
    ],
    icon: "global-groove.svg"
  },
  relaxation: {
    name: "Relaxing Meditation",
    description:
      "Slow, soothing music perfect for yoga, meditation, studying, or falling asleep.",
    value: "relaxation",
    filters: [
      {
        ...SONG_FILTERS.ambient_pulsing,
        selected: true
      },
      SONG_FILTERS.ambient_electronic,
      SONG_FILTERS.ambient_acoustic
    ],
    previewUrl:
      "https://storage.googleapis.com/boomy-songs/preview_meditation_OVERVIEW.mp3",
    credits: [
      {
        name: "@mitchellshow",
        url: "https://twitter.com/mitchellshow"
      }
    ],
    icon: "relaxing-meditation.svg"
  },
  beat: {
    name: "Experimental",
    description:
      "Very unpredictable results, free from genre constraints. Don't say we didn't warn you.",
    value: "beat",
    filters: [
      {
        ...SONG_FILTERS.modern_hip_hop,
        selected: true
      },
      SONG_FILTERS.hard_trap,
      SONG_FILTERS.max_edm,
      SONG_FILTERS.chill_electronic,
      SONG_FILTERS.vintage_beat,
      SONG_FILTERS.ambient,
      SONG_FILTERS.unlimited
    ],
    previewUrl:
      "https://storage.googleapis.com/boomy-songs/preview_beats_OVERVIEW.mp3",
    credits: [
      {
        name: "@mitchellshow",
        url: "https://twitter.com/mitchellshow"
      }
    ],
    icon: "experimental.svg"
  },
  avantnova: {
    name: "avantNova",
    description: "",
    value: "avantnova",
    filters: [
      {
        ...SONG_FILTERS.rule_26,
        selected: true
      },
      SONG_FILTERS.rule_195,
      SONG_FILTERS.rule_225,
      SONG_FILTERS.rule_110,
      SONG_FILTERS.rule_86
    ],
    previewUrl:
      "https://storage.googleapis.com/boomy-songs/preview_avantnova.mp3",
    credits: [
      {
        name: "algorhythms",
        url: "https://algorhythms.ai/"
      }
    ]
  },
  advanced: {
    name: "Custom",
    description:
      "Create without limits. Customize any style with your own composition and production instructions.",
    value: "advanced",
    previewUrl: "https://storage.googleapis.com/boomy-songs/CUSTOM.mp3",
    icon: "custom.svg"
  }
};

const createRoute = (
  name,
  path,
  hideNavOnMobile = false,
  verifiedOnly = false
) => ({
  path,
  name,
  hideNavOnMobile,
  verifiedOnly
});

const ROUTES = {
  home: createRoute("home", "/"),
  about: createRoute("about", "/about"),
  account: createRoute("account", "/account", false, true),
  accountRevenue: createRoute("accountRevenue", "/account/revenue", true, true),
  accountMembership: createRoute(
    "accountMembership",
    "/account/membership",
    false,
    true
  ),
  accountUser: createRoute("accountUser", "/account/user", false, true),
  accountContact: createRoute(
    "accountContact",
    "/account/contact",
    false,
    true
  ),
  admin: createRoute("admin", "/admin", false, true),
  createWithId: createRoute("createWithId", "/create/:id", true, true),
  create: createRoute("create", "/create", true, true),
  earn: createRoute("earn", "/earn", false, true),
  edit: createRoute("edit", "/edit/:id", true, true),
  editNotes: createRoute("edit", "/edit/notes/:id", true, true),
  editProduction: createRoute("edit", "/edit/production/:id", true, true),
  editSongInformation: createRoute(
    "editSongInformation",
    "/edit-info/:id",
    true,
    true
  ),
  eula: createRoute("eula", "/eula"),
  faqs: createRoute("faqs", "/faqs"),
  library: createRoute("library", "/library", false, true),
  release: createRoute("release", "/release", true, true),
  releaseCreate: createRoute("releaseCreate", "/release/create", true, true),
  releaseCreateSongs: createRoute(
    "releaseCreateSongs",
    "/release/create/songs",
    true,
    true
  ),
  releaseCreateSubmit: createRoute(
    "releaseCreateSubmit",
    "/release/create/submit",
    true,
    true
  ),
  releaseInfo: createRoute("releaseInfo", "/release/:id", true, true),
  editRelease: createRoute("editRelease", "/release/:id/edit", true, true),
  s: createRoute("s", "/s/:id"),
  signIn: createRoute("signIn", "/sign-in"),
  signUp: createRoute("signUp", "/sign-up"),
  song: createRoute("song", "/song/:id"),
  style: createRoute("style", "/style", true, true),
  terms: createRoute("terms", "/terms"),
  privacy: createRoute("privacy", "/privacy"),
  verify: createRoute("verify", "/verify"),
  addVocals: createRoute("addVocals", "/add-vocals/:id", true, true),
  rewriteSong: createRoute("rewriteSong", "/rewrite/:id", true, true),
  tag: createRoute("tag", "/tag/:id")
  // forceLandscape: createRoute("forceLandscape", "/force-landscape")
};

const PLAYER_CONTEXTS = {
  playback: "playback", //default for home/browse/library
  song: "song", // expended, locked, & autoPlay off
  create: "create", // expanded & locked
  vocal: "vocal", // expanded & locked
  hidden: "hidden" //hides the global player
};

const ENABLED_STYLES = [
  SONG_STYLES.wd_edm,
  SONG_STYLES.wd_rap,
  SONG_STYLES.wd_lofi,
  SONG_STYLES.wd_groove,
  SONG_STYLES.relaxation,
  SONG_STYLES.beat,
  SONG_STYLES.advanced
];

const PAUSED_STYLES = [];

const INSTRUMENTS = {
  whole_db_harmonic: {
    title: "All Instruments",
    value: "whole_db_harmonic"
  },
  acoustic_guitar_band: {
    title: "Acoustic Guitars",
    value: "acoustic_guitar_band"
  },
  acoustic_world_band: {
    title: "Global Ensemble",
    value: "acoustic_world_band"
  },
  all_acoustic: {
    title: "Acoustic Instruments",
    value: "all_acoustic"
  },
  chill_keys: {
    title: "Chill Keys",
    value: "chill_keys"
  },
  fusion_70s_band: {
    title: "Seventies Fusion",
    value: "fusion_70s_band"
  },
  jazz_50s_no_horns: {
    title: "Jazz Trio",
    value: "jazz_50s_no_horns"
  },
  rock_band: {
    title: "Rock n Roll",
    value: "rock_band"
  },
  soft_rock_band: {
    title: "Soft Rock",
    value: "soft_rock_band"
  },
  string_chamber: {
    title: "Classical Strings",
    value: "string_chamber"
  },
  synth_a: {
    title: "Synth Haven",
    value: "synth_a"
  },
  synth_w_acou_gtr: {
    title: "Smooth Pop",
    value: "synth_w_acou_gtr"
  },
  trap_flintstones: {
    title: "Carolina Trap Set",
    value: "trap_flintstones"
  },
  wind_chamber: {
    title: "Brass and Winds",
    value: "wind_chamber"
  }
};

const DRUMS = {
  whole_db_drums: {
    title: "All Drums",
    value: "whole_db_drums"
  },
  dusty: {
    title: "Dusty",
    value: "dusty"
  },
  edm: {
    title: "EDM",
    value: "edm"
  },
  experimental: {
    title: "Experimental",
    value: "experimental"
  },
  trap_808: {
    title: "Trap 808",
    value: "trap_808"
  },
  vintage_electronic: {
    title: "Vintage Electronic",
    value: "vintage_electronic"
  }
};

const MIXES = {
  clean: {
    title: "Super Clean",
    value: "clean"
  },
  cleanish: {
    title: "Studio A",
    value: "cleanish"
  },
  garage: {
    title: "New York Garage",
    value: "garage"
  },
  grand_canyon: {
    title: "Grand Canyon",
    value: "grand_canyon"
  },
  lofi: {
    title: "Vinyl Lofi",
    value: "lofi"
  },
  montreal: {
    title: "Montreal",
    value: "montreal"
  },
  toronto: {
    title: "Toronto",
    value: "toronto"
  },
  underwater: {
    title: "Aquarium",
    value: "underwater"
  },
  vancouver: {
    title: "Vancouver",
    value: "vancouver"
  },
  dm_house: {
    title: "Slow rolls",
    value: "dm_house"
  },
  dm_electro_house: {
    title: "Big Drops",
    value: "dm_electro_house"
  },
  dm_chill_wave: {
    title: "Vegas Baby",
    value: "dm_chill_wave"
  }
};

const SOUND_EFFECTS = {
  none: {
    title: "None",
    value: "none"
  },
  birds: {
    title: "Birds",
    value: "birds"
  },
  cars: {
    title: "Traffic",
    value: "cars"
  },
  creek: {
    title: "Creek",
    value: "creek"
  },
  insects: {
    title: "Insects",
    value: "insects"
  },
  jungle: {
    title: "Jungle",
    value: "jungle"
  },
  machines: {
    title: "Machines",
    value: "machines"
  },
  marsh: {
    title: "Marsh",
    value: "marsh"
  },
  plaza: {
    title: "Plaza",
    value: "plaza"
  },
  rain_heavy: {
    title: "Heavy Rain",
    value: "rain_heavy"
  },
  rain_light: {
    title: "Light Rain",
    value: "rain_light"
  },
  scifi: {
    title: "Sci-Fi",
    value: "scifi"
  },
  waves: {
    title: "Waves",
    value: "waves"
  }
};

const ABOUT_PAGE_COPY = {
  getting_started: {
    section_title: "Getting Started",
    section_content: [
      {
        prompt: "How does Boomy work?",
        text:
          "Boomy uses music automation technology powered by artificial intelligence, which you can use to create and save original songs in seconds for free. You can also create Releases and distribute them to all major streaming services and digital music retailers worldwide, and earn a share of royalties when your songs are played on networks like Spotify, Apple Music, TikTok, and YouTube."
      },
      {
        prompt: "How do I create a song on Boomy?",
        text:
          'Start by tapping "Create" and then "Song" from the menu. Then, choose a Style, select any custom settings, and tap "Create Song." Boomy will create an endless number of song options for you to reject, save, or customize.'
      },
      {
        prompt: 'What is a "Style?"',
        text:
          "Boomy uses AI-powered algorithms to emulate musical styles. Styles aren’t designed to be perfect copies of a genre, rather their design is influenced by aspects of a genre. Try different styles to see what you like!"
      },
      {
        prompt: "How do I reject a song option?",
        text:
          'Boomy’s Style algorithms attempt a variety of different approaches in each song option, so you’ll sometimes need to reject a few options before you find something you like.<br><br>When you hear a song you don’t like, simply tap the "Reject" button and a new option will appear. Don’t be afraid to reject song options, as this data helps Boomy improve.'
      },
      {
        prompt: "How do I save a song option?",
        text:
          'When you hear a song option you like, tap "Save" and the song will be added to your Library. You can also name your saved songs, add tags, add set privacy rules. <br><br>Once a song is in your Library, you’ll be able to copy it, download it, and add it to Releases.'
      },
      {
        prompt: "How do I customize my song on Boomy?",
        text:
          "When Boomy makes something you like, there are many ways to customize the song to your liking. <br><br> You can update or change the Production features of the song with new options like Tempo, Instruments, Mixing style. <br><br> You can also update or change the Composition of the song while keeping the same Production features. This re-writes the underlying notes of your song."
      },
      {
        prompt: 'What is "Composition?"',
        text:
          'Composition refers to the notes in your song. When you rewrite the composition of your song, you are changing the underlying notes, but keeping the same instruments. More information on Composition can be found <a class="teal-link" href="https://en.wikipedia.org/wiki/Musical_composition" target="_blank">here</a>.'
      },
      {
        prompt: 'What is "Production?"',
        text:
          'Production refers to the sounds in your song. This includes instruments, effects, and mixing styles, as well as more advanced audio processing like compression and normalization. More information about Production can be found <a class="teal-link" href="https://en.wikipedia.org/wiki/Sound_recording_and_reproduction" target="_blank">here</a>.'
      },
      {
        prompt: 'What is "Mixing?"',
        text:
          'Mixing refers to the balance between volumes of different instruments in your song, as well as certain effects like Reverb, Delay, and Compression. More information on Mixing can be found <a class="teal-link" href="https://en.wikipedia.org/wiki/Audio_mixing_(recorded_music)" target="_blank">here</a>.'
      },
      {
        prompt: "How do I use the Custom style?",
        text:
          'When you select "Custom" from the list of Styles, you have greater control over the Style algorithms. You can set options like Density and Tempo, and different Styles will have different customization options.'
      },
      {
        prompt: 'What is "Density?"',
        text:
          "In general, Density refers to the number of notes or individual sounds in a setting. A high Drum Density setting, for example, will result in many drum sounds in your song; a low Drum Density will result in fewer drum sounds. Try experimenting with style and density settings for novel and unexpected results."
      },
      {
        prompt: 'What is "Tempo?"',
        text:
          'Tempo is the speed of a song, normally represented in beats per minute or BPM. More information on Tempo can be found <a class="teal-link" href="https://en.wikipedia.org/wiki/Tempo" target="_blank">here</a>.'
      },
      {
        prompt: "How do I add vocals or sing over my Boomy songs?",
        text:
          'After tapping "Add Vocal" from a saved song, you can choose to add Custom vocals or try an experimental Auto-Vocal.<br><br>Custom vocals allow you to sing, rap, or add a top-line to your song. <br><br>Auto-Vocal, a beta feature, turns a short audio phrase or sample into an algorithmic vocal line. You can endlessly reject or save new Auto-Vocal options after you’ve added your audio phrase or sample.'
      }
    ]
  },
  boomy_songs: {
    section_title: "Using Boomy Songs",
    section_content: [
      {
        prompt: "Are Boomy songs original?",
        text:
          "Every song you create with Boomy is totally original, and while there can be stylistic similarities among songs in the same Style, you can safely assume each new output is unique."
      },
      {
        prompt: "Can I use Boomy songs royalty-free?",
        text:
          "Through our default license, you can use songs you create with Boomy for most commercial and non-commercial uses, including in your videos, podcasts, or other media. Please see Boomy’s EULA for excruciating detail."
      },
      {
        prompt: "Can I use Boomy songs in my videos?",
        text:
          "Yes! If you’re planning to use songs you create with Boomy in your videos, we strongly recommend adding your song to a Release first, which will enable us to collect a share of royalties for you from networks like YouTube and TikTok."
      },
      {
        prompt: "How do I download songs from Boomy?",
        text:
          'From your Library, tap the 3-dot menu on any of your songs and select "Download" to see options to download your song in various formats.'
      },
      {
        prompt: "Who owns the copyright to Boomy songs?",
        text:
          "Boomy Corporation owns and manages the copyright to songs created on the platform, in order to comply with relevant copyright regulation and streamline collection of your royalty share. <br><br> Through Boomy’s default license, you can use songs you create with Boomy for most commercial and non-commercial uses. <br><br> If you need copyright ownership of your song for your use case, please submit a request for copyright through the song’s menu item in Library. Please see our EULA for excruciating detail."
      }
    ]
  },
  releasing: {
    section_title: "Releasing Songs",
    section_content: [
      {
        prompt: 'What is a "Release?"',
        text:
          "A Release is an Album (collection of songs) or Single (one song) that contains one or more of your songs. With Boomy, you can create releases of your songs in minutes, and submit them to streaming services and music stores worldwide."
      },
      {
        prompt: "How do I create a Release on Boomy?",
        text:
          'Tap "Create" from the menu, then "Release." You’ll first need to enter information about your Release including a Title, Artist Name, Language, Genre, and other metadata. Then, add songs to your release. <br><br>When you’re finished adding songs, submit your release for review. Your release will be reviewed for compliance with standards imposed by streaming services and stores.'
      },
      {
        prompt:
          "What are the standards my release and song titles must follow to be approved?",
        text:
          'Please <a class="teal-link" href="https://help.apple.com/itc/musicstyleguide/en.lproj/static.html" target="_blank">click here</a> to review up-to-date guidelines.'
      },
      {
        prompt: 'Why does my release say "Pending?"',
        text:
          'While your Release is being reviewed, you’ll see a "Pending" status. Releases are generally reviewed within 1-4 business days. If your album has been "Pending" for an unusually long time, please contact help@boomy.com'
      },
      {
        prompt:
          "Which streaming services, stores, and digital retailers will my release be submitted to?",
        text:
          "Your release will be distributed to Spotify, Apple Music, Pandora, Amazon, Google Music, YouTube Music, YouTube, TikTok, Facebook, Instagram, Shazam, 24/7, 7 Digital, 8Tracks, Akazoo, Alibaba Music, Amie, Audiomack, AWA, Deezer, EOS, iHeartRadio, iMusica, Kanjian, KKBox, Line Music, Leeway, MediaNet, RealNetworks, NetEase, Neurotic Media, RX Music, Saavn, Slacker, SoundExchange, Tencent Music, Aspiro, TouchTunes, UMA Music, Yandez, and Zvook."
      },
      {
        prompt: "What is my share of royalties? How is it calculated?",
        text:
          "Royalties are calculated and reported by streaming services and stores, and rates vary widely depending on the outlet. While Boomy has no control over the rates paid by distribution partners, we actively seek all available royalties in order to maximize your earnings. <br><br> Your share of royalties is 80% net of distribution fees, which include fees imposed by distribution partners managing Boomy releases and transaction fees imposed by payout partners like PayPal and Stripe.<br><br>The remaining share of royalties is used by Boomy Corporation to fund operations and continue providing a free service."
      },
      {
        prompt: "How often is my share of royalties paid?",
        text:
          "Your share of royalties is deposited shortly after royalties are received by Boomy. Different stores and streaming services pay on different schedules, but are usually paid on a 2-3 month delay (for example, you’d receive your share of royalties for streams and sales in January in March or April). <br><br>Stores tend to report royalties at the end of the month, so be sure to regularly check your Boomy account to see when royalties are posted."
      },
      {
        prompt: "How do I withdraw my share of royalties?",
        text:
          'From your Account page, select "Revenue," then "Withdraw earnings" and follow the steps in the form. Royalty requests are generally processed in 1-4 business days. Please contact help@boomy.com if you have any questions about revenue share withdrawals.'
      },
      {
        prompt: "What payout methods does Boomy support?",
        text:
          'Boomy currently exclusively pays out through <a class="teal-link" href="https://paypal.com/us/smarthelp/article/FAQ4281" target="_blank">PayPal Payouts</a>, but is much explore payouts in cryptocurrency, including Bitcoin and Dogecoin.'
      }
    ]
  }
};

const mapFilters = (filters, style) =>
  Object.values(filters).map(filter => {
    return { title: filter.name, value: filter.value, style };
  });
const COMPOSITION_STYLES = {};
const ALL_FILTERS = [];
ENABLED_STYLES.forEach(style => {
  if (style.value !== SONG_STYLES.advanced.value) {
    const filters = mapFilters(style.filters, style.value);
    COMPOSITION_STYLES[style.value] = {
      title: style.name,
      list: filters
    };
    ALL_FILTERS.push(...filters);
  }
});

const RELEASE_STATUS = {
  DRAFT: null,
  SUBMITTED: 0,
  LIVE: 1,
  REJECTED: 2,
  FLAGGED: 3,
  APPROVED: 4,
  HOLD: 5
};

export {
  SONG_STYLES,
  SONG_FILTERS,
  PLAYER_CONTEXTS,
  ENABLED_STYLES,
  INSTRUMENTS,
  DRUMS,
  MIXES,
  COMPOSITION_STYLES,
  ALL_FILTERS,
  SOUND_EFFECTS,
  PAUSED_STYLES,
  ABOUT_PAGE_COPY,
  RELEASE_STATUS
};
